var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digit"},[_c('img',{attrs:{"src":(_vm.publicPath + "digits/" + _vm.value + ".svg"),"height":"80"}}),_c('span',{staticClass:"digit-label"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }